const TEXT =
	"Advanced audio protection technology platform designed and engineered in-house to deliver precision performance, reliable protection, and intelligent sound processing.";

export default function PoweredByDopple() {
	return (
		<section className="eo-dopple-band" aria-label="Powered by Dopple">
			<div className="container eo-dopple-band__grid">
				<img className="eo-dopple-band__badge" src="/brand/powered-by-dopple-white.svg" alt="Powered by Dopple" loading="lazy" />
				<p className="eo-dopple-band__text">{TEXT}</p>
				<a className="eo-button eo-button--outline" href="https://dopple.nl/" target="_blank" rel="noreferrer">
					Visit dopple.nl
				</a>
			</div>
		</section>
	);
}
